import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let ClbCheckController = {

    diemDanh: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/clb-check/create`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    diemDanhList: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/clb-check/list-student-check`,
            method: 'POST',
            body: payload
        }, callback);
    }
}

export default ClbCheckController
